import { useEffect } from 'react'
import HomePage from '@/app/page'
import AboutPage from '@/app/about/page'
import CommunityPage from '@/app/community/page'
import DocsPage from '@/app/docs/page'
import FaqPage from '@/app/faq/page'
import SupportPage from '@/app/support/page'
import RegisterPage from '@/app/register/page'
import LoginPage from '@/app/login/page'
import AccountPage from '@/app/account/page'
import ForumPage from '@/app/forum/page'
import ForumGalleryPage from '@/app/forum/gallery/page'
import NewTopicPage from '@/app/forum/new/page'
import ForumTopicPage from '@/app/forum/topic/[id]/page'
import PrivacyPage from '@/app/privacy/page'
import AdminPage from '@/app/admin/page'
import DownloadsPage from '@/app/downloads/page'
import DonatePage from '@/app/donate/page'

const routes: Record<string, { title: string; page: () => React.JSX.Element | null }> = {
  '/': { title: 'NewEmail — A calmer desktop inbox', page: HomePage },
  '/downloads': { title: 'Download NewEmail', page: DownloadsPage },
  '/donate': { title: 'Donate — NewEmail', page: DonatePage },
  '/about': { title: 'About — NewEmail', page: AboutPage },
  '/community': { title: 'Community — NewEmail', page: CommunityPage },
  '/docs': { title: 'Guide — NewEmail', page: DocsPage },
  '/faq': { title: 'FAQ — NewEmail', page: FaqPage },
  '/support': { title: 'Support — NewEmail', page: SupportPage },
  '/register': { title: 'Create Account — NewEmail', page: RegisterPage },
  '/login': { title: 'Log in — NewEmail', page: LoginPage },
  '/account': { title: 'Your Account — NewEmail', page: AccountPage },
  '/forum': { title: 'Community Forum — NewEmail', page: ForumPage },
  '/forum/gallery': { title: 'Community Gallery — NewEmail', page: ForumGalleryPage },
  '/forum/new': { title: 'New Topic — NewEmail Forum', page: NewTopicPage },
  '/privacy': { title: 'Privacy Policy — NewEmail', page: PrivacyPage },
  '/admin': { title: 'Admin — NewEmail', page: AdminPage },
}

export default function App() {
  const pathname = window.location.pathname.replace(/\/$/, '') || '/'
  const forumTopicMatch = pathname.match(/^\/forum\/topic\/(\d+)$/)
  const route =
    routes[pathname] ??
    (forumTopicMatch ? { title: 'Topic — NewEmail Forum', page: ForumTopicPage } : null) ??
    routes['/']
  const Page = route.page

  useEffect(() => {
    document.title = route.title
    if (window.location.hash) {
      requestAnimationFrame(() => document.querySelector(window.location.hash)?.scrollIntoView())
    }
  }, [route.title])

  return <Page />
}
